import moment from "moment";

export const parseRange = (rangeVal) => {
  if (!rangeVal) {
    return "";
  }

  const tmp = rangeVal.split("||").map((range) => {
    const values = range.split("|").map((value) => value?.trim());
    const firstValueParts = values[0].split("#");
    const firstValue = firstValueParts[0].trim();
    const firstUnit = firstValueParts[1] ? firstValueParts[1].trim() : "";

    const secondValueParts = values[1]
      ? values[1].split("#")
      : [undefined, undefined];
    const secondValue = secondValueParts[0] ? secondValueParts[0].trim() : "";
    const secondUnit = secondValueParts[1] ? secondValueParts[1].trim() : "";

    let result = "";

    if (firstValue) {
      result += `${firstValue}`;
    }

    if (firstValue && secondValue) {
      result += " to ";
    }

    if (secondValue) {
      result += `${secondValue}`;
    }
    if (firstUnit && secondUnit) {
      if (firstUnit === secondUnit) {
        result += ` ${firstUnit}`;
      } else {
        result = `${firstValue} ${firstUnit} to ${secondValue} ${secondUnit}`;
      }
    } else if (firstUnit) {
      result += ` ${firstUnit}`;
    } else if (secondUnit) {
      result += ` ${secondUnit}`;
    }

    return result;
  });

  return tmp.join(" , ");
};

export const accuracyFormat = (value) => {
  const regex = /^\d*\.?\d+(#.*)?$|^\d*\.?\d+[%]*[+]*\d*digit(#.*)?$/;
  return regex.test(value) ? `± ${parseRange(value)}` : parseRange(value);
};

export const DateisValid = (date, formate = "DD/MM/YYYY") => {
  if (date) {
    return moment(date).format(formate);
  }
  return "-";
};

export const DataisValid = (data) => {
  if (data) {
    return data;
  }
  return "";
};

export const parseEnvironment = (value, unit) =>{
  return value?.includes(unit)
    ? value.replace("#", " ")
    : value
    ? value + " " + unit
    : "\u00A0";
}

export const formatAverageOrSingleValue = (start, end, unit = "", discId = null) => {
  const s = parseFloat(start);
  const e = parseFloat(end);
  const hasS = !isNaN(s);
  const hasE = !isNaN(e);

  // Default decimal places
  let decimalPlaces = 1;
  // Discipline IDs that require 1 decimal place for humidity
  const specialDiscIds = ["16", "17", "18"];
  const isSpecialDisc = discId && specialDiscIds.includes(String(discId));
   // If not special, and unit is %RH (humidity), round to 0
  if (unit === "%RH" && !isSpecialDisc) {
    decimalPlaces = 0;
  }
  if (hasS && hasE) return ((s + e) / 2).toFixed(decimalPlaces) + ` ${unit}`;
  if (hasS) return s.toFixed(decimalPlaces) + ` ${unit}`;
  if (hasE) return e.toFixed(decimalPlaces) + ` ${unit}`;
  return "";
}
